import { render, staticRenderFns } from "./Parameters.vue?vue&type=template&id=5e0c64ca"
import script from "./Parameters.vue?vue&type=script&lang=js"
export * from "./Parameters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports